import React from 'react';
import MediaModal from "./MediaModal"


const CreateMediaModal = ({open, onClose, onSave})=>{

    return(
        <MediaModal open={open} onClose={onClose} onSave={onSave}/>
    )
}

export default CreateMediaModal